export default __webpack_public_path__ + "static/media/doctorpic.44f156fb.png";